import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal_heading-text" }
const _hoisted_2 = { class: "modal_caption" }
const _hoisted_3 = { class: "modal_text-input-container" }
const _hoisted_4 = { class: "modal_input-container" }
const _hoisted_5 = { class: "modal_input-container" }
const _hoisted_6 = { class: "modal_button-container" }
const _hoisted_7 = { class: "modal_error-container" }
const _hoisted_8 = {
  key: 0,
  class: "error-text"
}
const _hoisted_9 = { class: "modal_small-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_StepsCard = _resolveComponent("StepsCard")!

  return (_openBlock(), _createBlock(_component_StepsCard, { step: _ctx.currentStep }, {
    step: _withCtx(() => [
      _createTextVNode("Step " + _toDisplayString(_ctx.currentStep) + " of " + _toDisplayString(_ctx.totalSteps), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t('login.headingText')), 1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('login.caption')), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Input, {
            "aria-label": "Email",
            label: "Email address",
            type: "text",
            modelValue: _ctx.userInput.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userInput.email) = $event)),
            name: "email",
            rules: _ctx.rules.email
          }, null, 8, ["modelValue", "rules"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Input, {
            "aria-label": "Password",
            label: "Password",
            type: "password",
            modelValue: _ctx.userInput.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userInput.password) = $event)),
            name: "password",
            rules: _ctx.rules.password
          }, null, 8, ["modelValue", "rules"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _createVNode(_component_Button, {
            text: "Next",
            radius: 10,
            onButtonClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buttonClicked())),
            disabled: _ctx.isButtonDisabled
          }, null, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("small", null, _toDisplayString(_ctx.$t('login.passwordReset')), 1),
          _createVNode(_component_Popper, {
            arrow: "",
            content: "Contact your administrator to reset password",
            hover: true,
            class: "tooltip"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'circle-info'] })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["step"]))
}